import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { DevCycleService } from '@services/dev-cycle.service';
import { ApiService } from '@services/api.service';
import * as moment from 'moment';
import { PaymentTypes } from './split-payments/split-payment.component';

@Component({
  selector: 'ew-request-money',
  templateUrl: './request-money.component.html',
  styleUrls: ['./request-money.component.scss'],
})
export class RequestMoneyComponent implements OnInit {
  loading = true;
  startDate = new Date(1992, 0, 1);
  paymentLinkBaseUrl: string = `${window.location.origin}/public/payment-request/`;
  sellerPlatform = new FormControl('', [Validators.required]);
  language = new FormControl('', [Validators.required]);
  student: FormGroup = new FormGroup({
    platformId: new FormControl('', [
      Validators.required,
      Validators.maxLength(50),
    ]),
    firstname: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
    ]),
    lastname: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
    ]),
    country: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required, Validators.maxLength(60)]),
    address: new FormControl('', [
      Validators.required,
      Validators.maxLength(255),
    ]),
    postalCode: new FormControl('', [
      Validators.required,
      Validators.maxLength(10),
    ]),
    dateOfBirth: new FormControl('', [Validators.required]),
    email: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.maxLength(50),
    ]),
    phoneNumber: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
      Validators.maxLength(20),
      Validators.pattern('^[0-9\\(\\)\\-\\+\\s]*$'),
    ]),
  });
  order: FormGroup = new FormGroup({
    orderId: new FormControl('', [
      Validators.required,
      Validators.maxLength(128),
    ]),
    providerName: new FormControl('', [
      Validators.required,
      Validators.maxLength(150),
    ]),
  });
  payment: FormGroup = new FormGroup({
    amount: new FormControl('', [Validators.required]),
    currency: new FormControl('', [Validators.required]),
    currencyAccountId: new FormControl('', [Validators.required]),
    paymentType: new FormControl<PaymentTypes>(PaymentTypes.ONE_PAYMENT, [
      Validators.required,
    ]),
  });
  splits: FormArray | null = null;
  showSplitPaymentFeatureFlag = false;

  constructor(
    private API: ApiService,
    private devCycleService: DevCycleService,
  ) {}

  ngOnInit(): void {
    this.showSplitPaymentFeatureFlagFn();
  }

  get isSplitPayment() {
    return this.payment.value.paymentType === 'SPLIT_PAYMENT';
  }

  /**
   * returns the array of step validations
   * @author Martin Batun Tec.
   */
  get validations() {
    return [
      this.sellerPlatform.valid &&
        this.language.valid &&
        this.student.valid &&
        this.order.valid,
      this.payment.valid,
      this.splits?.valid ?? true,
      this.splits?.valid ?? true,
    ];
  }

  /**
   * send to create new payment request
   * @author Martin Batun Tec.
   */
  send(): void {
    this.student.value.dateOfBirth = moment(
      this.student.value.dateOfBirth,
    ).format('YYYY-MM-DD');

    this.API.post('v1/payment-requests/', {
      paymentLinkBaseUrl: this.paymentLinkBaseUrl,
      language: this.language.value,
      sellerPlatform: this.sellerPlatform.value,
      student: this.student.value,
      order: this.order.value,
      payment: {
        ...this.payment.value,
        splits: this.splits?.value.map((value: any[any]) => {
          return {
            ...value,
            bankAccountId: value.bankAccount?.bankAccountId,
          };
        }),
      },
    }).subscribe((data: any) => {
      this.paymentLinkBaseUrl = data.record.paymentLinkUrl;
      this.loading = false;
    });
  }

  /**
   * send notification after copy link
   * @author Martin Batun Tec.
   */
  copied(): void {
    this.API.alertService.success('alert:linkCopied');
  }

  async showSplitPaymentFeatureFlagFn() {
    this.showSplitPaymentFeatureFlag = await this.devCycleService.getVariable(
      'ew-1112-split-payments',
      false,
    );
  }

  setSplitForm(form: FormArray) {
    this.splits = form;
  }
}
